export default __webpack_public_path__ + "static/media/nantes.0f41fa83.webp";